const services = [
    {
        id : 1,
        title : {
            fr : 'Snack Bar',
            en : 'Snack Bar', 
        },
        description : {
            fr : "L'Hôtel West Heaven dispose un somptueux Snack bar pour vos moment de détente.",
            en : 'The West Heaven Hotel has a sumptuous snack bar for your relaxation.', 
        },
        image: 'assets/img/services/1.jpg'
    },
    {
        id : 2,
        title : {
            fr : 'Jardin Botanique',
            en : 'Botanic Garden', 
        },
        description : {
            fr : "Les chambres de l'Hôtel West Heaven offre une vue sur notre magnique jardin botanique",
            en : 'The rooms of the West Heaven Hotel offer a view of our beautiful botanical garden', 
        },
        image: 'assets/img/services/2.jpg'
    },
    {
        id : 3,
        title : {
            fr : 'Restaurant',
            en : 'Restaurant', 
        },
        description : {
            fr : "Vous pouvez enfin combler les attentes de vos papilles luxatives dans nôtre Restaurant étoilé",
            en : 'You can finally satisfy your taste buds in the starred restaurant of The West Heaven Hotel', 
        },
        image: 'assets/img/services/3.jpg'
    }
]

export default services